module.exports = __webpack_public_path__ + "static/img/RSG2-12V20A_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RSG2-12V20A_1.png
// module id = CAf4
// module chunks = 0